import { StrictMode, useEffect } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.tsx'
import { initGA } from './lib/analytics'
import { collectWebVitals } from './lib/webVitals'
import { initPWA } from './lib/pwa'

const helmetContext = {};

// App wrapper para inicializar analytics, web vitals e PWA
export function AppWithAnalytics() {
  useEffect(() => {
    initGA();
    collectWebVitals();
    initPWA();
  }, []);

  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider context={helmetContext}>
      <AppWithAnalytics />
    </HelmetProvider>
  </StrictMode>,
)
